<template>
    <div class="board" v-if="formData && errorData && errorLookup">
        <div class="bar">
            <b-icon icon="truck" class="icon"></b-icon>
            <span>ข้อมูลรถยนต์</span>
            <b-icon icon="chevron-down" class="collapse" @click="mixinsBoard_collapseContent(true)" v-if="!mixinsBoard_isShowContent"></b-icon>
            <b-icon icon="chevron-up" class="collapse" @click="mixinsBoard_collapseContent(false)" v-if="mixinsBoard_isShowContent"></b-icon>
        </div>

        <div class="content" v-show="mixinsBoard_isShowContent">
            <div class="form">
                <label>ทะเบียนรถ</label>
                <div class="row">
                    <div class="col-12 col-sm-6 col-md-4">
                        <div class="field">
                            <input type="text"
                                    v-model="formData.customer.licensePlate"
                                    class="input-field"
                                    :class="{ 'invalid': errorLookup.licensePlate.blank }"
                                    maxlength="10"
                                    :readonly="isLockLicensePlate || jobState === $Constants.JOB_STATUS_COMPLETE"
                                    placeholder="เลขทะเบียน" />
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4">
                        <div class="field">
                            <dropdown
                                v-model="formData.customer.licensePlateProvince"
                                placeholder="-- เลือกจังหวัด --"
                                :options="option.licensePlateProvince"
                                :disabled="isLockLicensePlate || jobState === $Constants.JOB_STATUS_COMPLETE"
                                :classes="{ input: ['input-field', (errorLookup.licensePlateProvince.blank ? 'invalid' : '')] }"
                            ></dropdown>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4" v-if="isShowLookupCar && !isCarFieldReady">
                        <div class="field">
                            <button class="btn btn-red" @click="lookupCarLicense()">ค้นหาทะเบียนลูกค้า</button>
                        </div>
                    </div>
                </div>

                <div class="text-center" v-if="isNewCustomer">
                    <button class="btn btn-block btn-dash btn-grey-outline" @click="showCarField()">เป็นลูกค้าใหม่</button>
                </div>

                <template v-if="isCarFieldReady">
                    <div class="row">
                        <div class="col-12 col-sm-6 col-md-4">
                            <div class="field">
                                <label>ยี่ห้อรถ</label>
                                <dropdown
                                    v-model="formData.customer.carBrand"
                                    placeholder="ยี่ห้อรถ"
                                    :options="option.carBrand"
                                    :disabled="jobState === $Constants.JOB_STATUS_COMPLETE"
                                    :classes="{ input: [ 'input-field', errorData.customer.carBrand.blank ? 'invalid' : '' ] }"
                                    @change="loadCarModel($event)"
                                ></dropdown>
                                <div class="input-error-message" v-if="errorData.customer.carBrand.blank">โปรดเลือกยี่ห้อรถ</div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4">
                            <div class="field">
                                <label>รุ่นรถ</label>
                                <dropdown
                                    v-model="formData.customer.carModel"
                                    placeholder="รุ่นรถ"
                                    :options="option.carModel"
                                    :disabled="jobState === $Constants.JOB_STATUS_COMPLETE"
                                    :classes="{ input: [ 'input-field', errorData.customer.carModel.blank ? 'invalid' : '' ] }"
                                    @change="loadCarYearSerie($event)"
                                ></dropdown>
                                <div class="input-error-message" v-if="errorData.customer.carModel.blank">โปรดเลือกรุ่นรถ</div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4">
                            <div class="field">
                                <label class="optional">ปีรถ</label>
                                <dropdown
                                    v-model="formData.customer.carYearSerie"
                                    placeholder="ปีรถ"
                                    :options="option.carYearSerie"
                                    :disabled="jobState === $Constants.JOB_STATUS_COMPLETE"
                                    :classes="{ input: 'input-field' }"
                                ></dropdown>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4">
                            <div class="field">
                                <label>เลขไมล์</label>
                                <input type="tel"
                                    v-model="formData.customer.distance"
                                    class="input-field"
                                    :class="{ 'invalid' : errorData.customer.distance.blank }"
                                    :readonly="jobState === $Constants.JOB_STATUS_COMPLETE"
                                    maxlength="7"
                                    @keypress="$AppUtility.inputOnlyNumber($event)"
                                    placeholder="เลขไมล์" />
                                <div class="input-error-message" v-if="errorData.customer.distance.blank">โปรดกรอกเลขไมล์</div>
                            </div>
                        </div>
                    </div>

                    <div class="field">
                        <label>ภาพถ่ายรถ ณ วันที่เข้ารับบริการ</label>
                        <div class="row">
                            <div class="col-sm-6 col-md-3 mb-2" v-for="index in totalPicture" :key="index">
                                <div class="input-picture">
                                    <template v-if="formData.customer.picture[index - 1]">
                                        <button @click="setPicture('', (index - 1))" v-if="jobState !== $Constants.JOB_STATUS_COMPLETE">
                                            <b-icon icon="x"></b-icon>
                                        </button>
                                        <img :src="formData.customer.picture[index - 1]" />
                                    </template>
                                </div>
                                <take-picture
                                    v-if="jobState !== $Constants.JOB_STATUS_COMPLETE"
                                    fileErrorTitle="ประเภทไฟล์ไม่ถูกต้อง!"
                                    fileErrorMessage="โปรดเลือกไฟล์รูปภาพที่เป็น JPG หรือ PNG เท่านั้น"
                                    @load="setPicture($event, (index - 1))"
                                >ถ่ายรูป</take-picture>
                            </div>
                        </div>
                        <div class="input-error-message text-center mb-2" v-if="errorData.customer.picture.blank">โปรดถ่ายรูปลูกค้า</div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-sm-6 col-md-4">
                            <div class="field">
                                <label>ชื่อผู้เข้ารับบริการ</label>
                                <input type="text" 
                                    v-model="formData.customer.customerFirstName"
                                    class="input-field"
                                    :class="{ 'invalid': errorData.customer.customerFirstName.blank }"
                                    :readonly="jobState === $Constants.JOB_STATUS_COMPLETE"
                                    maxlength="100"
                                    placeholder="ชื่อผู้เข้ารับบริการ" />
                                <div class="input-error-message" v-if="errorData.customer.customerFirstName.blank">โปรดกรอกชื่อผู้เข้ารับบริการ</div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4">
                            <div class="field">
                                <label>นามสกุลผู้เข้ารับบรีการ</label>
                                <input type="text"
                                    v-model="formData.customer.customerLastName"
                                    class="input-field"
                                    :class="{ 'invalid': errorData.customer.customerLastName.blank }"
                                    :readonly="jobState === $Constants.JOB_STATUS_COMPLETE"
                                    maxlength="100"
                                    placeholder="นามสกุลผู้เข้ารับบรีการ" />
                                <div class="input-error-message" v-if="errorData.customer.customerLastName.blank">โปรดกรอกนามสกุลผู้เข้ารับบรีการ</div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4">
                            <div class="field">
                                <label>เบอร์ติดต่อผู้เข้ารับบริการ</label>
                                <input type="text"
                                    v-model="formData.customer.customerTel"
                                    class="input-field"
                                    :class="{ 'invalid': errorData.customer.customerTel.blank }"
                                    :readonly="jobState === $Constants.JOB_STATUS_COMPLETE"
                                    maxlength="20"
                                    @keypress="$AppUtility.inputOnlyNumber($event)"
                                    placeholder="เบอร์ติดต่อผู้เข้ารับบริการ" />
                                <div class="input-error-message" v-if="errorData.customer.customerTel.blank">โปรดกรอกเบอร์ติดต่อผู้เข้ารับบริการ</div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>

            <div class="text-center mt-3" v-if="isCarFieldReady">
                <button class="btn btn-blue" :class="{ 'disabled': !isShowInspection }" @click="openModalCarInspection()">ใบตรวจสภาพรถ</button>
            </div>
        </div>

        <job-modal-car-inspection
            :isDisplay="isShowModalCarInspection" 
            :jobState="jobState"
            :keyData="keyData"
            :docNumber="docNumber"
            :customerData="customerData"
            :jobType="jobType"
            @hide="closeModalCarInspection()">
        </job-modal-car-inspection>
    </div>
</template>

<script>
import MixinThemeBoard from '@/theme/script/Board';
import MixinFormData from '@/components/job/FormData';
import JobModalCarInspection from '@/components/job/shared/ModalCarInspection';
import OptionLicensePlateProvince from '@/database/staticOption/LicensePlateProvince';
import DBCustomer from '@/database/Customer';

export default {
    mixins: [ MixinThemeBoard, MixinFormData ],
    components: {
        JobModalCarInspection
    },
    data() {
        return {
            totalPicture: 4,
            isNewCustomer: false,
            isCarFieldReady: false,
            isShowLookupCar: true,
            isLockLicensePlate: false,
            isShowInspection: false,
            isShowFinishCarInfoButton: true,
            isShowModalCarInspection: false,
            keyData: null,
            docNumber: null,
            formData: null,
            customerData: null,
            jobType: null,
            errorLookup: null,
            option: {
                licensePlateProvince: [],
                carBrand: [],
                carModel: [],
                carYearSerie: []
            }
        }
    },
    props: {
        jobState: Number,
        loadData: Object,
        errorData: Object
    },
    async mounted() {
        await this.initOptionData();
        this.pageLoad();
    },
    methods: {
        async initOptionData() {
            this.option.licensePlateProvince = OptionLicensePlateProvince.option;

            this.option.carBrand = await this.$AppUtility.setupCarBrandOption();
            this.option.carModel = [];
            this.option.carYearSerie = [];
        },
        pageLoad() {
            this.formData = this.initForm();
            this.$emit('formData', this.formData);
            this.errorLookup = this.initValidateLookup();
            this.initPictureField();

            if (this.loadData) {
                this.keyData = this.loadData.key;
                this.docNumber = this.loadData.number;
                this.customerData = {
                    customer: this.loadData.customer
                };
                this.jobType = {
                    jobType: this.loadData.jobType
                };

                if (this.loadData.status !== this.$Constants.JOB_STATUS_NEW) {
                    this.initPendingDisplay();
                }
            }
        },
        bindBookingData(bookingData) {
            if (bookingData) {
                this.formData.customer.licensePlate = bookingData.licensePlate;
                this.formData.customer.licensePlateProvince = bookingData.licensePlateProvince;
                this.formData.customer.carBrand = bookingData.carBrand;
                this.formData.customer.carModel = bookingData.carModel;
                this.formData.customer.carYearSerie = bookingData.carYearSerie;
                this.formData.customer.customerFirstName = bookingData.customerFirstName;
                this.formData.customer.customerLastName = bookingData.customerLastName;
                this.formData.customer.customerTel = bookingData.customerTel;
            }
            
            this.isCarFieldReady = true;
            this.isShowLookupCar = false;
            this.isLockLicensePlate = true;
        },
        initForm() {
            return {
                customer: {
                    licensePlate: this.loadData ? this.loadData.customer.licensePlate : '',
                    licensePlateProvince: this.loadData ? this.loadData.customer.licensePlateProvince : '',
                    carBrand: this.loadData ? this.loadData.customer.carBrand : '',
                    carModel: this.loadData ? this.loadData.customer.carModel : '',
                    carYearSerie: this.loadData ? this.loadData.customer.carYearSerie : '',
                    distance: this.loadData ? this.loadData.customer.distance : '',
                    picture: this.loadData ? this.loadData.customer.picture : [],
                    customerFirstName: this.loadData ? this.loadData.customer.customerFirstName : '',
                    customerLastName: this.loadData ? this.loadData.customer.customerLastName : '',
                    customerTel: this.loadData ? this.loadData.customer.customerTel : ''
                }
            };
        },
        initValidateLookup() {
            return {
                licensePlate: { blank: false },
                licensePlateProvince: { blank: false }
            };
        },
        initPictureField() {
            for (let index = 0; index < this.totalPicture - 1; index++) {
                this.formData.customer.picture.push('');
            }
        },
        setPicture(value, index) {
            this.$set(this.formData.customer.picture, index, value);
        },
        initPendingDisplay() {
            this.isCarFieldReady = true;
            this.isShowLookupCar = false;
            this.isShowInspection = true;
            this.isLockLicensePlate = true;
        },
        initCarInfoDisplay() {
            this.isCarFieldReady = true;
        },
        async lookupCarLicense() {
            if (this.validateLookup()) {
                const loader = this.$AppUtility.renderLoadBackdrop();

                // Check if license is exist
                const customerData = await DBCustomer.getDetailByLicensePlate(this.formData.customer.licensePlate, this.formData.customer.licensePlateProvince);

                if (customerData) {
                    this.formData.customer.carBrand = customerData.carBrand;
                    this.formData.customer.carModel = customerData.carModel;
                    this.formData.customer.carYearSerie = customerData.carYearSerie;
                    this.formData.customer.customerFirstName = customerData.customerFirstName;
                    this.formData.customer.customerLastName = customerData.customerLastName;
                    this.formData.customer.customerTel = customerData.customerTel;

                    this.showCarField();
                } else {
                    this.isNewCustomer = true;
                }

                loader.hide();
            }
        },
        validateLookup() {
            this.errorLookup = this.initValidateLookup();
            let valid = true;

            for (const property in this.errorLookup) {
                if (!this.formData.customer[property].trim()) {
                    this.errorLookup[property].blank = true;
                    valid = false;
                }
            }

            return valid;
        },
        async loadCarModel(value) {
            if (value) {
                const param = {
                    carBrand: value
                };

                this.option.carModel = await this.$AppUtility.setupCarModelOption(param);
            } else {
                this.option.carModel = [];
                this.option.carYearSerie = [];
                this.formData.customer.carModel = '';
                this.formData.customer.carYearSerie = '';
            }
        },
        async loadCarYearSerie(value) {
            if (value) {
                const param = { 
                    carBrand: this.formData.customer.carBrand,
                    carModel: value
                };

                this.option.carYearSerie = await this.$AppUtility.setupCarYearSerieOption(param);
            } else {
                this.option.carYearSerie = [];
                this.formData.customer.carYearSerie = '';
            }
        },
        showCarField() {
            this.isLockLicensePlate = true;
            this.isNewCustomer = false;
            this.isCarFieldReady = true;

            this.$emit('carInfoReady');
        },
        openModalCarInspection() {
            if (this.isShowInspection) {
                this.isShowModalCarInspection = true;
            } else {
                this.$swal({
                    title: 'ยังเปิดไม่ได้',
                    text: 'ต้องทำการเปิดใบงานก่อนเปิดใบตรวจสภาพรถ',
                    icon: 'error'
                });
            }
        },
        closeModalCarInspection() {
            this.isShowModalCarInspection = false;
        }
    }
}
</script>